<template>
    <div v-if="!formulario">

        <div id="sticker-win-wrapper" class="mx-auto mb-6">
            <div id="sticker-win">
                <div>
                    <span>{{$t('INOVAR')}}</span>
                    <span>{{$t('MOTIVAR')}}</span>
                </div>
            </div>
        </div>

        <div class="flex mb-6">
            <h1 class="mx-auto"><b>{{$t('Inovar_Motivar')}}</b></h1>
        </div>
        <div class="flex">
            <p class="mx-auto">{{$t('Participa_no_programa_Inovar_Motivar_e_habilita_te_a_ganhar')}}</p>
        </div>
        <div class="flex mb-6">
            <p class="mx-auto">{{$t('Vamos_contribuir_para_a_mudança_do_nosso_grupo')}}</p>
        </div>
        <div class="flex mb-6">
            <h4 class="mx-auto"><b>{{$t('Inova_e_Ganha')}}</b></h4>
        </div>
        <div class="flex">
            <div class="mx-auto">
                <div class="inline-block">
                    <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-file-text" @click="popup = true">{{$t('Regulamento')}}</vs-button>
                </div>
                <div class="inline-block">
                    <vs-button class="ml-3" color="primary" type="filled" icon-pack="feather" icon="icon-award" @click="goToForm()">{{$t('Participar')}}</vs-button>
                </div>
            </div>
        </div>
        <vs-popup :title="$t('Regulamento')" :active.sync="popup">

            <div id="topics">

                <ol id="topics-ol" class="numbers">
                    <li><span>1.</span>
                        {{$t('O_programa_visa_incentivar_a_participação_de_todos_no')}}
                    </li>
                    <li><span>2.</span>
                        {{$t('As_ideias_ou_sugestões_recebidas_até_ao_final_de_cada')}}
                    </li>
                    <li><span>3.</span>
                        {{$t('Para_participar_basta_preencher_o_formulário_em_papel')}}
                    </li>
                    <li><span>4.</span>
                        {{$t('As_ideias_apresentadas_serão_classificadas_em')}}
                        <ol class="numbers-inside">
                            <li>
                                {{$t('Relevantes_e_finalizadas_para_implementação_premiadas')}}
                            </li>
                            <li>
                                {{$t('Desenvolvimento_o_a_colaborador_a_será_convidado')}}
                            </li>
                            <li>
                                {{$t('Não_relevantes')}}
                            </li>
                        </ol>
                    </li>
                    <li><span>5.</span>
                        {{$t('A_s_ideia_s_premiada_s_recebem_um_prémio_no_valor')}}
                    </li>
                    <li><span>6.</span>
                        {{$t('Fatores_eliminatórios_apenas_a_sugestão_ou_ideia')}}
                        <ol class="numbers-inside">
                            <li>
                                {{$t('Inovação_e_originalidade')}}
                            </li>
                            <li>
                                {{$t('Valor_acrescentado_para_a_empresa')}}
                            </li>
                            <li>
                                {{$t('Necessidade de implementação')}}
                            </li>
                            <li>
                                {{$t('Exequibilidade_operacional')}}
                            </li>
                            <li>
                                {{$t('Método_de_implementação')}}
                            </li>
                            <li>
                                {{$t('Custos_de_implementação')}}
                            </li>
                        </ol>
                    </li>
                    <li><span>7.</span>
                        {{$t('As_ideias_ou_sugestões_relevantes_não_serão_premiadas')}}
                    </li>
                    <li><span>8.</span>
                        {{$t('Em_caso_de_ideias_similares_apenas_uma_será_premiada')}}
                        <ol class="numbers-inside">
                            <li>
                                {{$t('Mais_critérios_eliminatórios_adequados')}}
                            </li>
                            <li>
                                {{$t('Custos_de_implementação_calculados')}}
                            </li>
                            <li>
                                {{$t('Data_de_submissão')}}
                            </li>
                        </ol>
                    </li>
                    <li><span>9.</span>
                        {{$t('Ao_VG_LAB_avaliador_reserva_se_o_direito_de_não_atribuir')}}
                    </li>
                </ol>
            </div>

        </vs-popup>
    </div>
    <div v-else>
        <div class="w-full flex BotaoVoltar">
            <vs-button class="float-right mt-2" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left" @click="formulario = false">{{$t('returnButton')}}</vs-button>
        </div>
        <div class="w-full">
            <div class="w-full">

                <vs-input class="w-full mt-6 block" :label-placeholder="$t('Assunto')" v-model="assunto" />

                <v-select class="vue-select mt-6" :clearable="false" v-model="categoria" :options="categorias" label="name" :placeholder="$t('Categoria')">
                </v-select>

                <vs-textarea 
                class="w-full mt-6 block textarea" 
                v-model="descricao" 
                :placeholder="$t('Descrição')" 
                counter="4000"
                :counter-danger.sync="counterDanger"
                rows="5" />

                <div class="w-full mt-6 block giveSpaceContent">
                    <vs-button class="mt-5 mb20" v-on:click="addFiles()" color="primary" type="filled" icon-pack="feather" icon="icon-upload" v-if="file.length == 0">{{$t('Ficheiro')}}</vs-button>

                    <div class="pb35" v-if="file.length > 0">
                        <vs-chip @click="removeFile()" closable color="primary" close-icon="close">
                            <vs-avatar v-if="this.popupF.type == 'img'" :src="generateImgPath(file[0])" @click="popupFile()" :text="$t('Imagem')"/>
                            <vs-avatar v-else color="primary" icon-pack="feather" icon="icon-file-text" @click="popupFile()" />
                            {{ file[0]['name'] }}
                        </vs-chip>
                    </div>
                    <div class="hidden sm:hidden md:hidden lg:hidden">
                        <label>
                            <input type="file" id="fileImg" ref="f_file" v-on:change="handleFileUploads()"/>
                        </label>
                    </div>
                </div>

            </div>
            <div class="w-full flex mt-6">
                <vs-button @click="submitForm()" class="mt-3 mx-auto" color="primary" type="filled" icon-pack="feather" icon="icon-save">{{$t('submit')}}</vs-button>
            </div>

            <vs-popup :title="popupF.title" :active.sync="popupF.show" >
                <img v-if="popupF.type == 'img'" :src="popupF.src" class="w-full" />
                <embed v-if="popupF.type == 'pdf'" :src="popupF.src" width="960px" height="530px" />
                <div v-if="popupF.type == 'doc'" style="margin-top: 50px; min-height: 100px">{{$t('Não_é_possível_visualizar_o_documento')}}</div> 
            </vs-popup>
        </div>

        
    </div>

</template>

<script>

    export default {
        data(){
            return {
                popup: false,
                formulario: false,

                assunto: '',
                categoria: null,
                descricao: '',
                file: [],

                popupF: {
                    show: false,
                    title: '',
                    src: '',
                    type: '',
                },

                counterDanger: false,
                categorias: [],
                goSearch: '',
                found: 0,
            };
        },
        methods: {
            goToForm(){
                if(this.categorias.length == 0){
                    this.getCategories();
                }
                this.formulario = true;
                this.assunto = '';
                this.categoria = null;
                this.descricao = '';
                this.file = [];
            },
            getCategories(){
                this.$vs.loading();
                let that = this;
                this.$api({
                    method: 'get',
                    url: '/config/HumanResources/InnovateMotivateType',
                    params: {
                        token: this.$user.usertoken,
                    },
                })
                .then( function (res) {
                    that.categorias = res.data;
                }) 
                .catch( function (err) {
                    that.notify(err.response.data.message, 'red', 10);
                })
                .then( function () {
                    that.$vs.loading.close();
                });
            },
            addFiles(){
                if(this.file.length > 0){
                    this.notify(this.$t('Já_chegou_ao_limite_de_ficheiros'), 'red');
                    return;
                }
                this.$refs['f_file'].click();
            },
            removeFile(){
                this.file = [];
                this.popupF.src = '';
                this.popupF.title = '';
                this.popupF.type = '';
            },
            handleFileUploads(type, country){
                let uploadedFiles = this.$refs['f_file'].files[0];

                let FileSize = uploadedFiles.size / 1024 / 1024; // in MB
                if (FileSize < 10) {
                    // Tests if the uploaded file has the right extension
                    if (/\.(jpe?g|png|pdf|doc|docx)$/i.test(uploadedFiles.name)) {
                        //Adds the uploaded file to the files array
                        this.file.push(uploadedFiles);
                        if (/\.(jpe?g|png)$/i.test(uploadedFiles.name)) {
                            this.popupF.type = 'img';
                            this.popupF.src = this.generateImgPath(this.file[0]);
                        }
                        if (/\.(pdf)$/i.test(uploadedFiles.name)) {
                            this.popupF.type = 'pdf';
                            this.popupF.src = this.generateImgPath(this.file[0]);
                        }
                        if (/\.(doc|docx)$/i.test(uploadedFiles.name)) {
                            this.popupF.type = 'doc';
                        }
                    } else {
                        this.notify(this.$t('Apenas_são_aceites_PDFs_documentos_Word_ou_imagens'), 'red', 10);
                    }
                } else {
                    this.notify(this.$t('O_ficheiro_não_pode_ter_mais_de_10mb'), 'red', 10);
                }
            },
            popupFile(){
                this.popupF.title = this.file[0].name;
                this.popupF.show = true;
            },
            submitForm(){

                if(this.assunto == ''){
                    this.notify(this.$t('O_campo_Assunto_é_obrigatório'), 'red');
                    return false;
                }
                if(this.categoria == null){
                    this.notify(this.$t('O_campo_Categoria_é_obrigatório'), 'red');
                    return false;
                }
                if(this.descricao == ''){
                    this.notify(this.$t('O_campo_Descrição_é_obrigatório'), 'red');
                    return false;
                }
                if(this.descricao.length > 4000){
                    this.notify(this.$t('Passou_o_limite_de_caracteres_para_o_campo_Descrição'), 'red', 7);
                    return false;
                }

                this.$vs.loading();

                let formData = new FormData();
                this.buildFormData(formData,  {
                    name: this.assunto,
                    cod_type: this.categoria.cod_type,
                    description: this.descricao,
                    file_attachment: this.file[0],
                });

                let that = this;

                this.$api({
                    method: 'post',
                    url: '/human-resources/innovate-motivate?token=' + this.$user.usertoken,
                    data: formData,
                })
                .then( function (res) {
                    that.$vs.loading.close();
                    that.notify(that.$t('Participação_registada_com_sucesso'), 'green');
                    that.assunto = '';
                    that.categoria = null;
                    that.descricao = '';
                    that.file = [];
                    that.formulario = false;
                }) 
                .catch( function (err) {
                    that.$vs.loading.close();

                    let errors = err.response,
                        fields = [];
                        
                        if(errors && errors.data && errors.data.fields){
                            for (let prop in errors.data.fields) {
                                fields.push(errors.data.fields[prop]);
                            }
                            that.notify(fields.join("<br>"), 'red', 10);
                        } else if(errors && errors.data && errors.data.message){
                            that.notify(errors.data.message, 'red', 10);
                        } else {
                            that.notify(Erro, 'red', 10);
                        }
                });
            },
            buildFormData(formData, data, parentKey) {
                if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                    let that = this;
                    Object.keys(data).forEach(key => {
                        that.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                    });
                } else {
                    const value = data == null ? '' : data;
                    formData.append(parentKey, value);
                }
            },
        },
        created(){
        },
        components: {
        }
    }
</script>

<style scoped>
    .BotaoVoltar{
        justify-content: flex-end;
    }
    .textarea {
        border: 1px solid rgba(0, 0, 0, 0.2) !important;
        background-color: white;
    }

    #sticker-win-wrapper {
        /*position: relative;
        float: right;*/
        /*z-index: 100;*/
        /*right: 80px;
        margin-top: -65px;*/
        background: white;
        border: 7px solid #319CA6;
        transform: rotate(14deg);
        /* padding: 7px; */
        border-radius: 100px;
        width: 200px;
        height: 200px;
    }
    #sticker-win {
        position: relative;
        /*display: table;*/
        /*font-family: 'titilliumtext_bold';*/
        width: 175px;
        height: 175px;
        background: white;
        text-align: center;
        font-size: 32px;
        border-radius: 100px;
        border: 4px dashed #319CA6;
        color: #FFBB4C;
        font-weight: bold;
        line-height: 35px;
        cursor: default;
        left: 6px;
        top: 6px;
    }
    #sticker-win div {
        display: grid;
        padding-top: 44px;
        letter-spacing: -1px;
    }
    #sticker-win span:first-child {
        color: #6EC9C2;
    }


    #topics ol#topics-ol > li {
        display: block;
    }
    ol.numbers {
        list-style-type: decimal;
        margin: 0;
        padding: 0;
    }
    ol.numbers-inside {
        list-style-type: decimal;
        margin: 0;
        padding-left: 40px;
    }
    ol li span{
        font-weight: bold;
        color: #6EC9C2;
    }

    .giveSpaceContent div .con-vs-chip.vs-chip-primary.closable.con-color .text-chip .con-vs-avatar{
        height: 35px;
        width: 35px;
    }
</style>

